var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.forUpdate)?_c('CreateNewDeliveryOrder'):_vm._e(),(_vm.forUpdate)?_c('UpdateDeliveryOrder',{attrs:{"id":_vm.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }